import React, { useEffect, useState } from 'react';
import { useLanguage } from '../../../../context/LanguageContext';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import { withStyles } from '@material-ui/core/styles';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';

import './styles.scss';
import * as actions from '../../../../data/settings/actions';
import { STAFFID } from './../../../../data/constants/';
import { DefaultButton } from '../../../../components/Buttons';
import AlertDialog from '../../../../components/AlertDialog';

// Remove static label loading. Will load dynamically in component.

// TODO - PG - Languages are hard coded here
export const CustomFormControl = withStyles({
  root: {
    minWidth: 200,
    padding: 'inherit',
  }
})(FormControl);

export const ButtonFormControl = withStyles({
  root: {
    paddingLeft: '250px',
    paddingTop: '32px',
    minWidth: 150,
    padding: 'inherit',
  }
})(FormControl);

const SaveApplyButton = withStyles({
  root: {
    minWidth: 88,
    backgroundColor: 'rgba(229,229,229,0.7)',
    borderColor: '#5E5E5E',
    color: '#5E5E5E',
  },
})(DefaultButton);



const Language = props => {
  const { language, setLanguage, labels } = useLanguage();
  const [value, setValue] = useState(language === 'fr' ? 2 : 1);
  const [open, setOpen] = useState(false);
  const [disable, setDisable] = useState(true);

  useEffect(() => {
    setValue(language === 'fr' ? 2 : 1);
  }, [language]);



  const handleChange = (event) => {
    setValue(event.target.value);
    setDisable(false);
  };



  const handleOk = () => {
    const lang = value === 1 ? 'EN' : 'fr';
    const staffId = sessionStorage.getItem(STAFFID);
    const checked = JSON.parse(sessionStorage.getItem('chk'));
    props.handleSaveLanguage(staffId, lang, checked);
    setOpen(false);
    setDisable(false);
    setLanguage(lang); // Update context, triggers re-render globally
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false)
  };


  const saveLabel = (<span><span>{labels.SETTINGS.LANGUAGE?.message}</span><br /></span>);
  return (
    <div>
      <Card style={{ marginTop: 20 }}>
        <CardHeader title={labels.SETTINGS.LANGUAGE?.title} className="Open-Search-Head" />
        <CardContent>
          <CustomFormControl>
            <InputLabel id="simple-select-label">{labels.SETTINGS.LANGUAGE?.subTtitle}</InputLabel>
            <Select value={value || 1} onChange={(e) => handleChange(e)}>
              <MenuItem value={1} >{labels.SETTINGS.LANGUAGE?.english}</MenuItem>
              <MenuItem value={2} >{labels.SETTINGS.LANGUAGE?.french}</MenuItem>
            </Select>
          </CustomFormControl>
          <ButtonFormControl>
            <SaveApplyButton
              onClick={() => handleOpen()}
              className="button-actions"
              disabled={disable}
            >{labels.SETTINGS.LANGUAGE?.save}</SaveApplyButton>
          </ButtonFormControl>
        </CardContent>
      </Card>
      <AlertDialog
        alertDialogTitle={labels.SETTINGS.LANGUAGE?.dialog}
        openAlertDialog={open}
        alertDialogMessage={saveLabel}
        handleOk={() => handleOk()}
        handleCancel={() => handleClose()}
        okButtonLabel={labels.SETTINGS.LANGUAGE?.yes}
        cancelButtonLabel={labels.SETTINGS.LANGUAGE?.no}
      />
    </div>
  );
}
Language.defaultProps = {
  handleSaveLanguage: () => { },
  getUserInfo: () => { },
  staffId: '',
  getLanguage: () => {},
};
Language.propTypes = {
  handleSaveLanguage: PropTypes.func,
};
const mapStateToProps = state => ({ ...state.home });

const mapDispatchToProps = dispatch => ({
  getUserInfo: staffId =>
    dispatch(actions.getUserInfo(staffId)),
  getLanguage: staffId =>
    dispatch(actions.getLanguage(staffId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Language);
